import prettyBytes from "pretty-bytes";
import { FC, Props } from "./typings";
import styles from "./styles.module.scss";
import NewIcon from "assets/icons/new_tab.svg?react";
import DowloadIcon from "assets/icons/download.svg?react";
import AttachIcon from "assets/icons/folder_dossier_added.svg?react";
import AcceptanceSignIcon from "assets/icons/signature.svg?react";
import TransferToAcceptanceModal from "components/TransferToAcceptanceModal";
import { useState } from "react";
import AttachmentIconComponent from "components/AttachmentIconComponent";
import sanitizeHtml from "sanitize-html";
import { useDownloadFileStore } from "store/downloadFile.store";
import Loading from "components/Loading";
import { Can } from "contexts/AbilityContext";
import { Checkbox, Tooltip } from "@mui/material";
import { isArchiveAttachment } from "utils/isAllowedAttachment";
import { useTranslation } from "react-i18next";

const PackageAttachment: FC<Props> = ({
  date,
  attachment,
  onPreview,
  onDownload,
  onNewWindow,
  onAddDossier,
  className = "",
  disableMenu = false,
  sizeInColumn = false,
  dateInColumn = false,
  handleDoubleClick = null,
  showCheckbox,
  isChecked,
  handleAttachmentChecked,
}) => {
  const { t } = useTranslation();
  const [showMenu, setShowMenu] = useState(false);
  const [showTransfer, setShowTransfer] = useState(false);
  // const [{ opacity }, dragRef] = useDrag(
  //   () => ({
  //     type: "attachment",
  //     item: { id: attachment.Id },
  //     collect: (monitor) => ({
  //       opacity: monitor.isDragging() ? 0.5 : 1,
  //     }),
  //   }),
  //   []
  // );

  const { id, progress } = useDownloadFileStore();

  const checkIsArchive = (fileName: string) => {
    fileName = fileName.toLocaleLowerCase();
    const extension = fileName.split(".").at(-1);
    const isAllowed = isArchiveAttachment(extension ?? "no");

    return isAllowed;
  };

  const isArchive = checkIsArchive(attachment.FileName);

  const handleClickOnFile = () => {
    onPreview(attachment);
  };

  return (
    <div
      // ref={dragRef}
      // style={{ opacity }}
      data-is={true}
      onMouseEnter={() => setShowMenu(true)}
      onMouseLeave={() => setShowMenu(false)}
      onClick={(e) => {
        handleClickOnFile(e);
        e.stopPropagation();
        e.preventDefault();
      }}
      onDoubleClick={() => {
        handleDoubleClick?.(attachment);
      }}
      className={`${styles.wrapper} ${className}`}
    >
      <div className={styles.content}>
        <div data-is={true}>
          <AttachmentIconComponent
            data-is={true}
            className={styles.iconPDF}
            file={attachment?.FileName ?? ""}
            onClick={() => handleClickOnFile}
          />
        </div>
        <div className={styles.metaData} data-is={true}>
          <div
            data-is={true}
            className={styles.title}
            dangerouslySetInnerHTML={{
              __html: sanitizeHtml(
                attachment?.Label?.length
                  ? attachment.Label
                  : attachment?.FileName ?? "",
              ),
            }}
          ></div>
          {!sizeInColumn && (
            <div data-is={true} className={styles.size}>
              {attachment?.Size &&
                attachment?.Size > 0 &&
                prettyBytes(attachment?.Size ?? 0)}{" "}
              {date && !dateInColumn && <>{date}</>}
            </div>
          )}
        </div>
        {showMenu && !disableMenu && (
          <div className={styles.menu}>
            {!isArchive && onNewWindow && (
              <Tooltip title={t("tooltips.openInNewTab")}>
                <div>
                  <NewIcon onClick={() => onNewWindow(attachment)} />
                </div>
              </Tooltip>
            )}

            <Tooltip title={t("common.download")}>
              <div>
                <DowloadIcon
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    onDownload(attachment);
                  }}
                />
              </div>
            </Tooltip>

            <Can I="accessModule" an="drive">
              {onAddDossier && (
                <Tooltip title={t("chat.attachToDossier")}>
                  <div>
                    <AttachIcon onClick={() => onAddDossier(attachment)} />
                  </div>
                </Tooltip>
              )}
            </Can>

            <Tooltip title="Do akceptacji/podpisu">
              <div>
                <AcceptanceSignIcon
                  onClick={(e) => {
                    e.preventDefault();
                    e.stopPropagation();
                    setShowTransfer(true);
                  }}
                />
              </div>
            </Tooltip>
          </div>
        )}
        {sizeInColumn && (
          <div data-is={true} className={styles.size}>
            {attachment?.Size &&
              attachment?.Size > 0 &&
              prettyBytes(attachment?.Size ?? 0)}{" "}
            {date && <>{date}</>}
          </div>
        )}
        {dateInColumn && (
          <div data-is={true} className={styles.size}>
            {date && <>{date}</>}
          </div>
        )}

        {showCheckbox && (
          <div className={styles.checkbox}>
            <Tooltip title={t("tooltips.attachToCaseDossier")}>
              <Checkbox
                checked={isChecked}
                onChange={(s) => {
                  console.log("On change", s.target.checked);
                  handleAttachmentChecked(attachment, s.target.checked);
                }}
              ></Checkbox>
            </Tooltip>
          </div>
        )}
        {/* {attachment.ShowInDossier > 0 &&
          !showMenu &&
          !disableMenu &&
          onAddDossier && (
            <Can I="accessModule" an="drive">
              <AttachIcon onClick={() => onAddDossier(attachment)} />
            </Can>
          )} */}
      </div>
      <div
        style={{
          width: id === attachment.Id ? `${progress}%` : "0%",
        }}
        className={styles.bar}
      ></div>
      {id === attachment.Id && (
        <div className={styles.loading}>
          <Loading withoutText />
        </div>
      )}

      {showTransfer && (
        <TransferToAcceptanceModal
          file={{
            title: attachment?.Label || attachment?.FileName || "Plik",
            fileName: attachment?.FileName,
            fileUri: attachment?.Uri,
            encryptionKeyId: attachment?.EncryptionKeyId,
            documentType: "package",
            documentId: attachment?.Id,
          }}
          onClose={() => setShowTransfer(false)}
        />
      )}
    </div>
  );
};

export default PackageAttachment;
